import { TextArea } from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';

import './PhraseEditor.css';

export interface PhraseEditorProps {
    value: string;
    onChange: (value: string) => void;
    error?: string;
}

export class PhraseEditor extends React.Component<PhraseEditorProps> {
    render() {
        const { value, error } = this.props;
        let errorContent;

        if (error) {
            errorContent = (
                <div className={Bem.cls('phrase-editor', 'errors')}>
                    {error}
                </div>
            );
        }

        return (
            <div className={Bem.cls('phrase-editor')}>
                <div className={Bem.cls('phrase-editor', 'phrase')}>
                    <TextArea
                        text={value}
                        theme={'normal'}
                        size={'s'}
                        rows={3}
                        cls={Bem.cls('phrase-editor', 'phrase-input')}
                        onBlur={this.onBlur}
                        onChange={this.onChange}
                    />
                </div>

                {errorContent}
            </div>
        );
    }

    private onChange = (sum: string) => {
        this.props.onChange(sum);
    };

    private onBlur = () => {
        this.props.onChange(this.props.value);
    };
}
